import { envInfo } from '@/PROFILE_CONSTANTS';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import Configuration from '@/Configuration';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCookies from 'vue-cookies';

// document.cookie = "au_guid=42e63295cbc30263fdc6a813c3657785%3AqaPK%2BOBoGmeCFlAK3LZhbAqx9*u5S6l20GmdkSsRL0YphXsv%2BvsK4RDiFg6X*RPW;";
// document.cookie += "au_profile_guid=0c4533f5-c3c2-ea11-a812-000d3a59fabf;";

if (process.env.SENTRY_DSN) {
	Sentry.init({
		dsn: process.env.SENTRY_DSN,
		environment: Configuration.currentConfiguration().SENTRY_ENVIRONMENT,
		Vue
	});
}

console.log(envInfo());

VueCookies.config('2h');
Vue.use(VueCookies);

//Loop through the exports of global.js
import { VueMasonryPlugin } from 'vue-masonry';
import VuePaginate from 'vue-paginate';
import VTooltip from 'v-tooltip';
import vueDebounce from 'vue-debounce'

Vue.use(VueMasonryPlugin);
Vue.use(VuePaginate);
Vue.use(VTooltip);
Vue.use(vueDebounce);

if (process.env.NODE_ENV !== 'production') {
	require('@/assets/lib/bootstrap.scss');
	import('./assets/lib/bootstrap.scss');
}

// Loop over global components folder and import and then export them
const globalComponents = require.context(
	'./components/global/',
	true,
	/\.(js|vue)$/i
);
globalComponents.keys().map(key => {
	const name = key.match(/\w+/)[0];
	return Vue.component(name, globalComponents(key).default);
});

// Loop over global components icons folder and import and then export them
const globalIcons = require.context(
	'./components/global/icons',
	true,
	/\.(js|vue)$/i
);
globalIcons.keys().map(key => {
	const name = key.match(/\w+/)[0];
	return Vue.component(name, globalIcons(key).default);
});

Vue.config.productionTip = false;

import './assets/scss/all.scss';

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
